import { createAsyncThunk } from "@reduxjs/toolkit";

import magnifiAPI from "../../services/api/magnifi";

export const getOverlays = createAsyncThunk("overlays/get", async (payload) => {
  try {
    const response = await magnifiAPI.getOverlays(payload);
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});
